import { TUTORIAL_BULK_ACTIONS } from 'constants/tutorials';
import getTutorialCovers from './getTutorialCovers';

export default getTutorialCovers(TUTORIAL_BULK_ACTIONS);
